import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const EnvelopeIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9145 0.310875L13.4145 4.54188C13.7835 4.82588 14 5.26487 14 5.73087V12.2384C14 12.6364 13.842 13.0179 13.5605 13.2989C13.2795 13.5804 12.898 13.7384 12.5 13.7384H1.5C1.102 13.7384 0.720499 13.5804 0.439499 13.2989C0.157999 13.0179 0 12.6364 0 12.2384V5.73087C0 5.26487 0.216499 4.82588 0.585499 4.54188L6.0855 0.310875C6.6245 -0.103625 7.3755 -0.103625 7.9145 0.310875ZM7.305 1.10387C7.125 0.965374 6.875 0.965374 6.695 1.10387L1.195 5.33437C1.072 5.42937 1 5.57537 1 5.73087V12.2384C1 12.3709 1.0525 12.4984 1.1465 12.5919C1.24 12.6859 1.3675 12.7384 1.5 12.7384H12.5C12.6325 12.7384 12.76 12.6859 12.8535 12.5919C12.9475 12.4984 13 12.3709 13 12.2384V5.73087C13 5.57537 12.928 5.42937 12.805 5.33437L7.305 1.10387ZM2.735 6.90739C2.501 6.76139 2.4295 6.45238 2.576 6.21838C2.722 5.98438 3.0305 5.91288 3.265 6.05938L7.019 8.40289L10.7335 6.06039C10.9665 5.91339 11.2755 5.98338 11.423 6.21638C11.57 6.44988 11.5 6.75888 11.2665 6.90638L7.287 9.41637C7.1245 9.51887 6.918 9.51938 6.7555 9.41738L2.735 6.90739Z"
        fill="currentColor"
      />
    </svg>
  )
})

EnvelopeIcon.displayName = 'EnvelopeIcon'
